import * as z from "zod";

/** One Ask Redo turn for the public MCP `ask_redo` tool, as the calling user. */
export const askRedoPublicMcp = {
  name: "askRedoPublicMcp" as const,
  input: z.object({
    message: z.string(),
    teamId: z.string(),
    userId: z.string(),
    threadId: z.string().optional(),
  }),
  output: z.object({
    message: z.string(),
    threadId: z.string(),
    /** The given threadId was a legacy conversation, so this turn started a new thread. */
    previousThreadNotContinued: z.boolean(),
  }),
};
